import {
  StatusActiveIcon,
  StatusDraftIcon,
  StatusInactiveIcon,
} from '../icons/StatusIcons';
import type { StatusDropdownConfigMap } from '@/components/ui/status-dropdown';
import type { User } from '@api/users';

/** Pending is a state an account arrives in, not one anybody sets, so it
 *  labels the trigger but is not offered as a choice. */
export const SELECTABLE_USER_STATUSES = ['verified', 'closed'] as const;

export function createUserStatusDropdownConfig(
  labels: Record<User['status'], string>,
): StatusDropdownConfigMap<User['status']> {
  return {
    verified: {
      label: labels.verified,
      activeTextClassName: 'text-confirmed-green',
      inactiveTextClassName: 'text-grey',
      icon: (isActive) => (
        <StatusActiveIcon className={isActive ? 'text-confirmed-green' : 'text-grey'} />
      ),
    },
    unverified: {
      label: labels.unverified,
      activeTextClassName: 'text-turmeric-yellow',
      inactiveTextClassName: 'text-grey',
      icon: (isActive) => (
        <StatusDraftIcon className={isActive ? 'text-turmeric-yellow' : 'text-grey'} />
      ),
    },
    closed: {
      label: labels.closed,
      activeTextClassName: 'text-grey',
      inactiveTextClassName: 'text-grey',
      icon: () => <StatusInactiveIcon className="text-grey" />,
    },
  };
}
